import portal from 'core/assets/svg/portal.svg';
import contact from 'core/assets/svg/contact.svg';
import pieChart from 'core/assets/svg/pie-chart.svg';
import pen from 'core/assets/svg/pen.svg';
import tool from 'core/assets/svg/tool.svg';
import puzzlePiece from 'core/assets/svg/puzzle-piece.svg';
import lifeInsurance from 'core/assets/svg/life-insurance.svg';
import claim from 'core/assets/svg/claim.svg';

export default [
  {
    route: 'updates',
    src: 'https://portal.ourbranch.com/ebd//f79f122fa8bb4c6d80d82b4ebbb7e00a',
    title: 'Updates',
    iconSrc: portal
  },
  {
    route: 'underwriting',
    src: 'https://portal.ourbranch.com/ebd//c44e478eb85e4369ba6fa0ab07f26c74',
    title: 'Underwriting',
    iconSrc: pen
  },
  {
    route: 'tools',
    src: 'https://portal.ourbranch.com/ebd//98730a3c688c4c4b86b235ee84ce981e',
    title: 'Resources',
    iconSrc: tool
  },
  {
    route: 'training',
    src: 'https://portal.ourbranch.com/ebd//473fbb17df5f41bb9080164f25205d51',
    title: 'Training',
    iconSrc: puzzlePiece
  },
  {
    route: 'life-insurance',
    src: 'https://portal.ourbranch.com/ebd//81cac880cc984cd5b60fc15d64a8e10c',
    title: 'Life Insurance',
    iconSrc: lifeInsurance
  },
  {
    route: 'claims',
    src: 'https://portal.ourbranch.com/ebd//9a767baeb2c0464c80a847642629e720',
    title: 'Claims',
    iconSrc: claim
  },
  {
    route: 'contact-us',
    src: 'https://portal.ourbranch.com/ebd//29421786cff74f0e806dff853085cf19',
    title: 'Contact Us',
    iconSrc: contact
  }
];
